import { boolean, object } from 'yup';
import { nullableStringNumberSchema } from 'common/validationSchemas/stringNumberSchema';
import {
  getRequiredErrorMessage,
  getMinErrorMessage,
  getMaxErrorMessage,
} from 'common/utils/validation';
import inputErrors from 'common/messages/inputErrors';
import { formatPrice } from 'common/utils';

export const getMinMaxPeiceSchema = (min = 0, max = Infinity) =>
  object().shape(
    {
      value: nullableStringNumberSchema.when('editable', {
        is: true,
        then: nullableStringNumberSchema.when(['minValue', 'maxValue'], (minValue, maxValue) =>
          nullableStringNumberSchema
            .min(Number(minValue) ? Number(minValue) : Number(min), () =>
              getMinErrorMessage({
                min: formatPrice(Number(minValue) ? Number(minValue) : Number(min)),
              }),
            )
            .max(Number.isInteger(maxValue) ? Number(maxValue) : Number(max), () =>
              getMaxErrorMessage({
                max: formatPrice(Number.isInteger(maxValue) ? Number(maxValue) : Number(max)),
              }),
            )
            .required(getRequiredErrorMessage),
        ),
        otherwise: nullableStringNumberSchema
          .min(Number(min), () => getMinErrorMessage({ min: formatPrice(min) }))
          .required(getRequiredErrorMessage),
      }),
      editable: boolean(),
      minValue: nullableStringNumberSchema.when('editable', {
        is: true,
        then: nullableStringNumberSchema
          .required(getRequiredErrorMessage)
          .when('maxValue', maxValue =>
            nullableStringNumberSchema
              .required(getRequiredErrorMessage)
              .min(Number(min), () => getMinErrorMessage({ min: formatPrice(min) }))
              .max(Number(maxValue) ? maxValue : Infinity, () =>
                getMaxErrorMessage({ max: formatPrice(Number(maxValue) ? maxValue : Infinity) }),
              ),
          ),
      }),
      maxValue: nullableStringNumberSchema.when('editable', {
        is: true,
        then: nullableStringNumberSchema
          .required(getRequiredErrorMessage)
          .when(['minValue', 'maxValue'], (minValue, maxValue) =>
            nullableStringNumberSchema
              .required(getRequiredErrorMessage)
              .min(Number(min), () => getMinErrorMessage({ min: formatPrice(min) }))
              .max(Number(maxValue) ? maxValue : Infinity, () =>
                getMaxErrorMessage({ max: formatPrice(Number(maxValue) ? maxValue : Infinity) }),
              )
              .min(Number(minValue), () => inputErrors.minMaxError),
          ),
      }),
    },
    [['maxValue', 'maxValue']],
  );

export const minMaxPeiceSchema = getMinMaxPeiceSchema();
